// src/components/PhotoGallery.js
import React, { useState } from 'react';

function PhotoGallery({ photos }) {
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    const openLightbox = (photo) => {
        setSelectedPhoto(photo);
        document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
        setSelectedPhoto(null);
        document.body.style.overflow = 'auto';
    };

    if (!photos || photos.length === 0) {
        return (
            <div className="no-photos">
                <p>아직 등록된 사진이 없습니다.</p>
            </div>
        );
    }

    return (
        <>
            <div className="photo-gallery-grid">
                {photos.map((photo) => (
                    <div
                        key={photo.id}
                        className="photo-item"
                        onClick={() => openLightbox(photo)}
                    >
                        <img
                            src={photo.thumbnail || photo.url}
                            alt={photo.caption}
                            loading="lazy"
                        />
                        <div className="photo-overlay">
                            <span className="photo-caption">{photo.caption}</span>
                        </div>
                    </div>
                ))}
            </div>

            {/* Lightbox Modal */}
            {selectedPhoto && (
                <div className="lightbox-overlay" onClick={closeLightbox}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="lightbox-close"
                            onClick={closeLightbox}
                            aria-label="닫기"
                        >
                            ×
                        </button>
                        <img src={selectedPhoto.url} alt={selectedPhoto.caption} />
                        <div className="lightbox-info">
                            <p className="lightbox-caption">{selectedPhoto.caption}</p>
                            <p className="lightbox-date">{selectedPhoto.date}</p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default PhotoGallery;
